import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext.jsx';
import { readSupportHandoff } from '@/lib/supportPresentation.mjs';

// Use the established preference setter; do not replace the language lifecycle.
export default function useSupportLanguage() {
  const { pathname, search } = useLocation();
  const { setLanguage } = useLanguage();
  const applied = useRef('');
  const context = readSupportHandoff(search, pathname);
  useEffect(() => {
    const key = `${pathname}${search}`;
    if (!context.language || applied.current === key) return;
    applied.current = key;
    setLanguage(context.language);
  }, [pathname, search, context.language, setLanguage]);
  return context;
}
